/**
 * Lightweight client-side wishlist (no app/backend) — persists liked
 * product/variant ids in localStorage per browser, toggled from the heart
 * button rendered on product cards. Updates the header wishlist icon's
 * count bubble in sync.
 */
(function () {
  var STORAGE_KEY = 'routine_wishlist';

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(ids) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (error) {
      /* localStorage unavailable (private mode, quota) — fail silently */
    }
  }

  function updateCountBubbles(count) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
  }

  function toggleWishlist(id) {
    var ids = getWishlist();
    var index = ids.indexOf(id);
    var added;
    if (index === -1) {
      ids.push(id);
      added = true;
    } else {
      ids.splice(index, 1);
      added = false;
    }
    saveWishlist(ids);
    updateCountBubbles(ids.length);
    return added;
  }

  function refreshButtons() {
    var ids = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var id = button.getAttribute('data-wishlist-toggle');
      var active = ids.indexOf(id) !== -1;
      button.classList.toggle('is-wishlisted', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    updateCountBubbles(ids.length);
  }

  function handleClick(event) {
    var button = event.currentTarget;
    var id = button.getAttribute('data-wishlist-toggle');
    if (!id) return;
    event.preventDefault();
    event.stopPropagation();
    var added = toggleWishlist(id);
    button.classList.toggle('is-wishlisted', added);
    button.setAttribute('aria-pressed', added ? 'true' : 'false');
  }

  function init() {
    refreshButtons();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      button.addEventListener('click', handleClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
